//version 1.4

var $ = require('jquery');
var jQuery = $
window.$ = $
window.jQuery = $
var jquery = $;

// use the code below to search for orPrm interfaces in the javascript global scope
/*
window.srchcnt = 0;
window.checkedobjects=[];
window.recursesearchorprm = function(path, obj,lvl,printall){
	if (!lvl){lvl=0;}
	lvl++;
	window.checkedobjects.push(obj);
	for (var x in obj){
		window.srchcnt++;
		if(printall){
			TCL.log(path+"."+x)
			TCL.log(typeof obj[x]);
			TCL.log(obj[x]);
		}
		//TCL.log(path+"."+x);
		//if (window.srchcnt>1000){return;}
		
		if(x.indexOf('orPrm')>=0 || x.indexOf('orprm')>=0){
			TCL.log(path+"."+x)
			TCL.log(typeof obj[x]);
			TCL.log(obj[x]);
			printall=true;
		}
		else {
			printall=false;
		}
		if ((typeof obj[x]) == 'object' && lvl<4 && window.checkedobjects.indexOf(obj[x])<0){
			var nf = new function(path,obj,lvl,printall){
				var cp = path;
				var ob = obj;
				var lv = lvl;
				var pta = printall;
				this.evl = function(){
					window.recursesearchorprm(cp,ob,lv,pta);
				};
			}(path+"."+x, obj[x],lvl,printall);
			setTimeout(nf.evl,0);
		}
	}
};
*/


/*$( window ).on('beforeunload',function(args) {
  return "Handler for .unload() called.";
});*/

export default function() {

	/*if (window.external !== undefined && window.external.orPrmWidgetId !== undefined && null !== window.external.orPrmWidgetId) {*/
		var iwuqeyroq8476y4trg = this;
		this.bluring = false;
		this.isAsync = false;
		this.widgetId = -1;
		this.orPrmConnector = {};
		this.operCount = 0;
		this.adjustableSize = true;
		this.radioGroups = {};
		this.isInitialized = false; /* !!!! BACKWARD COMPATIBILITY ONLY - USE THE ASYNC FUNCTION properInitialization WHENEVER POSIIBLE*/
		this.properInitialization = async function(){
			return _properInitializationDeferred.promise();
		};
		var _properInitializationDeferred = $.Deferred();
		var _properInitializationResolve = function(){
			if(_properInitializationDeferred.state() =='pending'){
				_properInitializationDeferred.resolve();
			}
		};
		var _properInitializationReject = function(){
			if(_properInitializationDeferred.state() =='pending'){
				_properInitializationDeferred.reject(_properInitializationErrorMessage);
			}
		};
		var _properInitializationErrorMessage = "";
		var _nextId = 0;
		var _awaitingCallbacks = {};
		this.log = function(msg,level) {
		if (document.getElementById("logarea")) {
			document.getElementById("logarea").value += msg + "\r\n";
			}
			if(!this.isInitialized){
				_properInitializationErrorMessage +=msg + "\r\n";
			}
		};
		this.escapeTCL = function(str,noquote) {
		TCL.log("no quote: " + noquote, 1);
			noquote=noquote|false;
		if (typeof str !== "string") {
				try {
					str = str.toString();
				} catch (e) {
				TCL.log("ERROR in escapeTCL");
					TCL.log(e.message);
					TCL.log(e.stack);
				str = "";
				}
			}
		TCL.log("no quote: " + noquote, 1);
		var strOst = "";
			if (noquote) {
				//str = str.replace(/([\{\}\\"\[\]\$])/g, '\\$1');
			TCL.log("no quote: " + str, 1);
			} else {
			str = '"' + str.replace(/([\{\}\\"\[\]\$])/g, "\\$1") + '"';
			}
			
			var ln = str.length;
			var decCode = 0;
			for ( var x = 0; x < ln; x++) {
				decCode = str.charCodeAt(x);
				if (decCode > 126) {
				strOst += "\\u" + ("0000" + decCode.toString(16)).substr(-4);
				} else {
					strOst += str[x];
				}
			}

			return strOst;
		};
		
		this.eval = function(actionName, params) {
			if (params === undefined) {
				params = [];
			} else if (!(params instanceof Array)) {
				params = [ params ];
			}
			
			if(iwuqeyroq8476y4trg.isAsync) {
			}
		var comstr =
			"::orFlowWuia::jsIntercept " +
			iwuqeyroq8476y4trg.escapeTCL(actionName) +
			" " +
			iwuqeyroq8476y4trg.widgetId;
			var count = params.length;
			for ( var x = 0; x < count; x++) {
				TCL.log(params[x]);
			comstr += " " + iwuqeyroq8476y4trg.escapeTCL(params[x]);
			TCL.log(comstr.split(" "));
			}

			var ret;
			var robj;
			try {
			TCL.log("executing" + comstr);
				if(iwuqeyroq8476y4trg.isAsync){
					ret = iwuqeyroq8476y4trg.orPrmConnector("executeTcl", [comstr]);
					return {};
				} else {
					ret = iwuqeyroq8476y4trg.orPrmConnector("executeTcl", comstr);
				TCL.log("the sync answer is: " + ret);
					robj = JSON.parse(ret);
					return robj;
				}
			} catch (e) {
			TCL.log("ERROR in eval");
				TCL.log(e.message);
				TCL.log(e.stack);
				robj = null;
			}
		};
		var adjustSizeCallback = function(data){
		iwuqeyroq8476y4trg.log("the async answer is: " + data);
		var mv = document.getElementById("main-container");
		if (typeof data == "string") {
				try {
					opcData = JSON.parse(data);
				} catch (e) {
					opcData = data;
				}
			} else {
				opcData = data;
			}
			
		if (
			opcData.status &&
			opcData.satus == "OK" &&
			(mv.offsetWidth != window.innerWidth ||
				mv.offsetHeight != window.innerHeight)
		) {
			iwuqeyroq8476y4trg.log("further resizing required");
				setTimeout(iwuqeyroq8476y4trg.adjustSize, 0);
			} else if(iwuqeyroq8476y4trg.isAsync){
			iwuqeyroq8476y4trg.log("removing callback hook");
			if (window.orPrmConnector.removeMessageCallback) {
				window.orPrmConnector.removeMessageCallback(
					"executeTcl",
					adjustSizeCallback
				);
			} else {
				window.orPrmConnector.deleteMessageCallback(
					"executeTcl",
					adjustSizeCallback
				);
			}
			iwuqeyroq8476y4trg.log("callback hook removed");
		}
		};
		this.adjustSize = function() {
			//alert('a');
			if (!TCL.adjustableSize) {
			return void 0;
			}

		var mv = document.getElementById("main-container");
			TCL.log(mv.offsetWidth ,123);
			TCL.log(mv.offsetHeight ,123);
			TCL.log(window.outerWidth,123);
			TCL.log(window.innerWidth,123);
			TCL.log(window.outerHeight,123);
			TCL.log(window.innerHeight,123);
			if(iwuqeyroq8476y4trg.isAsync){
			window.orPrmConnector.setMessageCallback(
				"executeTcl",
				adjustSizeCallback
			);
			}
			
		var opcData = iwuqeyroq8476y4trg.eval("adjustSize", [
			mv.offsetWidth + /*window.outerWidth*/ -window.innerWidth,
			mv.offsetHeight + /*window.outerHeight*/ -window.innerHeight,
		]);
		if (!iwuqeyroq8476y4trg.isAsync) {
			adjustSizeCallback(opcData);
			}
			
		return void 0;
		};
		
		this.bindInner = function(elem,nsArray) {
			if (nsArray) {
			TCL.log("adding attr", 3);
			$(elem).attr("tcl-bind-inner", nsArray);
			}
		
		answ = iwuqeyroq8476y4trg.eval("bindValue", [
			$(elem).attr("tcl-bind-inner"),
			$(elem).attr("name") ? $(elem).attr("name") : $(elem).attr("name-org"),
			elem.innerHTML,
			1,
		]);
		return 0;
		};
		
		this.bindValue = function(elem,nsArray) {
		TCL.log("binding value for:" + elem.name + " , of type:" + elem.type, 8);
			if (nsArray) {
			TCL.log("adding attr", 3);
			$(elem).attr("tcl-bind-data", nsArray);
			}
			
		TCL.log("sending", 3);
		if (elem.type == "radio") {
			var group = $(elem).attr("name");
					var inGroup = $('*[name="'+group+'"]');
			var val = "";
					var count2 = inGroup.length;
					for ( var y = 0; y < count2; y++) {
						if(inGroup[y].checked){
							val = inGroup[y].value;
							iwuqeyroq8476y4trg.radioGroups[group]=val;
							break;
						}
					}
			answ = iwuqeyroq8476y4trg.eval("bindValue", [
				$(elem).attr("tcl-bind-data"),
				elem.name,
				val,
				1,
			]);
			$(elem).bind("change input", function () {
				var group = $(this).attr("name");
							var inGroup = $('*[name="'+group+'"]');
				var val = "";
							var count2 = inGroup.length;
							for ( var y = 0; y < count2; y++) {
								if(inGroup[y].checked){
									val = inGroup[y].value;
									break;
								}
							}
							if (iwuqeyroq8476y4trg.radioGroups[group]==val) {
								return;
							}
				TCL.log("sending");
				answ = iwuqeyroq8476y4trg.eval("bindValue", [
					$(this).attr("tcl-bind-data"),
					this.name,
					val,
					0,
				]);
							iwuqeyroq8476y4trg.radioGroups[group]=val;
				if ($(this).attr("tcl-bind-change") != undefined) {
					TCL.log(
						"will trigger bind on change: " +
						TCL.escapeTCL($(this).attr("tcl-bind-change"), true),
						2
					);
					answ = iwuqeyroq8476y4trg.eval(
						"evaluate",
						$(this).attr("tcl-bind-change")
					);
				}
						});
		} else if (elem.type == "checkbox") {
			answ = iwuqeyroq8476y4trg.eval("bindValue", [
				$(elem).attr("tcl-bind-data"),
				elem.name,
				elem.checked ? 1 : 0,
				1,
			]);
					elem.valast = elem.checked?1:0;
			$(elem).bind("change input", function () {
						var val = this.checked?1:0;
						if (this.valast === undefined || this.valast!=val) {
					TCL.log("sending");
							
					answ = iwuqeyroq8476y4trg.eval("bindValue", [
						$(this).attr("tcl-bind-data"),
						this.name,
						val,
						0,
					]);
							this.valast = val;
					if ($(this).attr("tcl-bind-change") != undefined) {
						answ = iwuqeyroq8476y4trg.eval(
							"evaluate",
							$(this).attr("tcl-bind-change")
						);
					}
						}
						});
				} else {
			answ = iwuqeyroq8476y4trg.eval("bindValue", [
				$(elem).attr("tcl-bind-data"),
				elem.name,
				elem.value,
				1,
			]);
					elem.valast = elem.value;
			var checkifcheckbox = $("[name-org='" + $(elem).attr("name") + "']");
					if(checkifcheckbox.length==1){
				$(checkifcheckbox[0]).bind("change", function () {
					var ddf = new (function (o) {
						this.o = o;
						this.f = function () {
							$(o).change();
						};
					})(elem);
							setTimeout(ddf.f,0);
						});
					}
			$(elem).bind("keyup change drop paste input", function () {
						if (this.valast === undefined || this.valast!=this.value) {
					TCL.log("sending");
					answ = iwuqeyroq8476y4trg.eval("bindValue", [
						$(this).attr("tcl-bind-data"),
						this.name,
						this.value,
						0,
					]);
							this.valast = this.value;
					if ($(this).attr("tcl-bind-change") != undefined) {
						answ = iwuqeyroq8476y4trg.eval(
							"evaluate",
							$(this).attr("tcl-bind-change")
						);
					}
						}
						});
				}
		};

		this.bindValues = function() {
		TCL.log("bindv");
			
		var list = $("*[tcl-bind-inner]");
			var count = list.length;
			for ( var x = 0; x < count; x++) {
			TCL.log("bindinnerhtml", 3);
			iwuqeyroq8476y4trg.bindInner(list[x]);
			TCL.log("bound", 3);
			}
		var list = $("*[tcl-bind-data]");
			var count = list.length;
			for ( var x = 0; x < count; x++) {
			TCL.log("bindvalue", 3);
			iwuqeyroq8476y4trg.bindValue(list[x]);
			TCL.log("ound", 3);
			}
		};
		this.bindInnerValues = function(elem) {
		TCL.log("bindv");
			
		var list = $(elem).find("*[tcl-bind-inner]");
			var count = list.length;
			for ( var x = 0; x < count; x++) {
			TCL.log("bindinnerhtml", 3);
			iwuqeyroq8476y4trg.bindInner(list[x]);
			TCL.log("bound", 3);
			}
		var list = $(elem).find("*[tcl-bind-data]");
			var count = list.length;
			for ( var x = 0; x < count; x++) {
			TCL.log("bindvalue", 3);
			iwuqeyroq8476y4trg.bindValue(list[x]);
			TCL.log("ound", 3);
			}
		};
		
		this.updateBoundElement = function(id,nsArrayName,value) {
		TCL.log(
			"calling custom handler if exists for TCL.inCallbacks[" +
			nsArrayName +
			"][" +
			id +
			"]",
			1
		);
		if (
			TCL.inCallbacks &&
			TCL.inCallbacks[nsArrayName] &&
			TCL.inCallbacks[nsArrayName][id] &&
			typeof TCL.inCallbacks[nsArrayName][id] == "function"
		) {
			TCL.log("exists for TCL.inCallbacks[" + nsArrayName + "][" + id + "]", 1);
				TCL.inCallbacks[nsArrayName][id](value);
			} else {
			TCL.log("doesn't exist", 1);
			}
		TCL.log("updateBoundElement start", 1);
			var matching = $('*[name-org="'+id+'"]');
			var cnt12 = matching.length;
			if(cnt12==0){
				matching = $('*[name="'+id+'"]');
			TCL.log("looking for org-name " + id + " . found " + cnt12, 1);
				cnt12 = matching.length;
			TCL.log("looking for name " + id + " . found " + cnt12, 1);
			}
			var forInner = false;
		TCL.log("looking for innerHTML declared bindings", 1);
			for (var sic = 0; sic<cnt12;sic++) {
			if ($(matching[sic]).attr("tcl-bind-inner") == nsArrayName) {
					forInner = true;
				TCL.log("found, assigning value: " + value, 1);
					matching[sic].innerHTML = value;
				TCL.log("assigned, checking if is option list", 1);
				if (matching[sic].type && matching[sic].type.substr(0, 6) == "select") {
						//$('select').each(function(){ //need to run in .each to refresh all the elements
					TCL.log("it is", 1);
						try{
						$(matching[sic]).data("combobox").refresh();
						} catch(e){
						TCL.log("ERROR in updateBoundElement");
							TCL.log(e.message);
							TCL.log(e.stack);
						}
							
						//});
					} else {
					TCL.log("it is not", 1);
					TCL.log("building delegae", 1);
					var delegate = new (function (el) {
							var el1 = el;
							this.execute = function(){
							TCL.log("trying to bind new elements values", 1);
								TCL.bindInnerValues(el1);
							TCL.log("trying to bind new elements events", 1);
								TCL.bindInnerEvents(el1);
							};
					})(matching[sic]);
					TCL.log("setting a timeout for new bindings", 1);
						setTimeout(delegate.execute,0);
					}
				}
			}
			if (forInner) {
				return;
			}
			var matching = $('*[name="'+id+'"]');
			var cnt12 = matching.length;
			if(matching.length>1){
				var inGroup = matching;
			TCL.log("items in group: " + inGroup.length, 1);
				var count2 = inGroup.length;
				for ( var y = 0; y < count2; y++) {
				TCL.log(
					"value of element is: " +
					inGroup[y].value +
					"  , while assigned value is: " +
					value,
					1
				);
					if(inGroup[y].value == value){
						inGroup[y].checked=true;
						iwuqeyroq8476y4trg.radioGroups[id]=value;
						break;
					} else {
						inGroup[y].checked=false;
					}
					iwuqeyroq8476y4trg.radioGroups[id]=value;
				}
			} else if (matching.length == 1) {
			TCL.log("fondbyid", 1);
			if (matching[0].type == "checkbox") {
				var newval = value == 1 ? true : false;
					matching[0].checked = newval;
					matching[0].valast = newval;
				} else {
					matching[0].value = value;
					matching[0].valast = value;
				}
			}
		};
		this.bindEvent = function(elem) {
		$(elem).bind("click", function () {
			TCL.log(TCL.escapeTCL($(this).attr("tcl-bind-click")));
			answ = iwuqeyroq8476y4trg.eval(
				"evaluate",
				$(this).attr("tcl-bind-click")
			);
					});
		};
		
		this.bindEvents = function() {
		TCL.log("bindev");
		var list = $("*[tcl-bind-click]");
			var count = list.length;
			for ( var x = 0; x < count; x++) {
			TCL.log("bindevent", 3);
			iwuqeyroq8476y4trg.bindEvent(list[x]);
			TCL.log("bound", 3);
			}
		};
		
		this.bindInnerEvents = function(elem) {
		TCL.log("bindev");
		var list = $(elem).find("*[tcl-bind-click]");
			var count = list.length;
			for ( var x = 0; x < count; x++) {
			TCL.log("bindevent", 3);
			iwuqeyroq8476y4trg.bindEvent(list[x]);
			TCL.log("bound", 3);
			}
		};
		
		this.preventEnter = function() {
		TCL.log("preventing leaving on enter", 1);
		$("input").keydown(function (e) {
			if (e.keyCode == 13 && $(this).attr("type") != "submit") {
					e.preventDefault();
				TCL.log($(this).attr("type"), 4);
				}
			});
		TCL.log("preventing leaving on esc", 1);
		$("input").keydown(function (e) {
				if(e.keyCode == 27 ) {
					e.preventDefault();
				TCL.log($(this).attr("type"), 4);
				}
			});
		};
		
		this.prepareComboBoxes = function() {
			try {
			$(".combobox").combobox();
			} catch (e) {
			TCL.log("ERROR in prepareComboBoxes");
				TCL.log(e.message);
				TCL.log(e.stack);
			}
	};
		
		var setupBundings = function(){
			try {
				iwuqeyroq8476y4trg.prepareComboBoxes();
				iwuqeyroq8476y4trg.bindValues();
				iwuqeyroq8476y4trg.bindEvents();
			iwuqeyroq8476y4trg.eval("onLoaded");
			setTimeout(_properInitializationResolve,0);
			} catch (e) {
			iwuqeyroq8476y4trg.log("ERROR in setupBundings");
				iwuqeyroq8476y4trg.log(e.message);
				iwuqeyroq8476y4trg.log(e.stack);
				setTimeout(_properInitializationReject,0);
			}
		};
		
		this.setupEnv = function(widgetId) {
			if(iwuqeyroq8476y4trg.isInitialized){
			iwuqeyroq8476y4trg.log(
				"Already initialized, further initialization not needed"
			);
				return;
		}
			iwuqeyroq8476y4trg.isInitialized = true;
		iwuqeyroq8476y4trg.log("Setting widgetId to: " + widgetId.toString());
			iwuqeyroq8476y4trg.widgetId = widgetId;
			setTimeout(setupBundings,0);
			
	};
	var getUrlParameter = function (name) {
		name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
		var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
		var results = regex.exec(location.search);
		return results === null
			? ""
			: decodeURIComponent(results[1].replace(/\+/g, " "));
	};
			
	var getNextId = function () {
		return ++_nextId;
	};
	var prepareTclCommand = function (commandAndParams) {
		for (var i in commandAndParams) {
			commandAndParams[i] = iwuqeyroq8476y4trg.escapeTCL(commandAndParams[i]);
		}
		commandAndParams = commandAndParams.join(" ");
		return commandAndParams;
	};
	this.broadcast = function (command, parameters) {
		if (parameters instanceof Array) {
			var commandWithArgs = prepareTclCommand([command].concat(parameters));
		} else {
			var commandWithArgs = prepareTclCommand(arguments)
		}
		TCL.eval("evaluate", commandWithArgs);
	};
	this.defer = function (command, parameters) {
		if (parameters instanceof Array) {
			var commandWithArgs = prepareTclCommand([command].concat(parameters));
		} else {
			var commandWithArgs = prepareTclCommand(arguments)
		}
		TCL.log("deferring: " + commandWithArgs);
		var curId = getNextId();
		commandWithArgs = "::orFlowWuia::defer " + commandWithArgs + " " + curId;
		TCL.log("whole cmd: " + commandWithArgs);
		var d = $.Deferred();
		_awaitingCallbacks[curId] = d;
		TCL.eval("evaluate", commandWithArgs);
		return d.promise();
	};
	this.callback = function (callbackId, response) {
		TCL.log("callback id: " + callbackId);
		TCL.log("callback response: " + JSON.stringify(response));
		if (_awaitingCallbacks[callbackId]) {
			var d = _awaitingCallbacks[callbackId];
			delete _awaitingCallbacks[callbackId];
			TCL.log("found callback for id: " + callbackId);
			if (response) {
				TCL.log("completing with response data");
				if (response.status && response.status == "OK") {
					TCL.log("resolving with data");
					d.resolve(response.data);
				} else {
					TCL.log("rejecting with data");
					d.reject(response.data);
				}
			} else {
				TCL.log("resolving with no data");
				d.resolve({});
			}
		}
	};

	var globalForceConfirm = false;
	this.confirm = function (text) {
		if (globalForceConfirm) {
			return $.Deferred().resolve({ confirmed: true }).promise();
		}
		// return $.Deferred().resolve({ status: 'OK', data: { confirmed: true } }).promise();
		var cmd = "::orFlowWuia::confirmPromise " + TCL.escapeTCL(text);
		return iwuqeyroq8476y4trg.defer(cmd);
	};
	this.popupError = function (text) {
		iwuqeyroq8476y4trg.broadcast("::orFlowWuia::popupError " + TCL.escapeTCL(text) + ";#");
	};
	this.popupWarning = function (text) {
		iwuqeyroq8476y4trg.broadcast(
			"::orFlowWuia::popupWarning " + TCL.escapeTCL(text) + ";#"
		);
	};
	this.popupInfo = function (text) {
		iwuqeyroq8476y4trg.broadcast("::orFlowWuia::popup " + TCL.escapeTCL(text) + ";#");
		};
		
		this.init = function() {
			try {
				
				setTimeout(_properInitializationReject,30000);
		iwuqeyroq8476y4trg.log("Initializing GUI");
		iwuqeyroq8476y4trg.log("Locating theme");
		var theme='';
		if((theme = getUrlParameter("orFlowWuiaColorTheme")) == ""){
			var theme = 'light';
		}
		var theme_css_link = document.getElementById('theme_css');
		if (theme_css_link !== null) {
			iwuqeyroq8476y4trg.log("Setting theme '"+theme+"'");
			theme_css_link.href = 'css/theme_'+theme+'.css?ver='+Date.now().toString();
		}
		iwuqeyroq8476y4trg.log("Browser engine used: " + navigator.userAgent);
		var hasCPHBridge = window.hasOwnProperty("cdsCPHBridge");
			if(hasCPHBridge){
			iwuqeyroq8476y4trg.log("CPHBridge sync env detected");
				iwuqeyroq8476y4trg.log(JSON.stringify(window.cdsCPHBridge, null, 4));
				iwuqeyroq8476y4trg.orPrmConnector = window.cdsCPHBridge.orPrmConnector;
				iwuqeyroq8476y4trg.isAsync = false;
			var wid = "";
			if ((wid = getUrlParameter("orFlowWuiaWidgetId")) != "") {
				wid = parseInt(wid);
				iwuqeyroq8476y4trg.log(
					"WidgetId received as a param: " + wid.toString()
				);
					iwuqeyroq8476y4trg.setupEnv(wid);
			} else if (
				window.cdsCPHBridge.orPrmWidgetId !== undefined &&
				window.cdsCPHBridge.orPrmWidgetId !== null &&
				window.cdsCPHBridge.orPrmWidgetId >= 0
			) {
					iwuqeyroq8476y4trg.setupEnv(window.cdsCPHBridge.orPrmWidgetId);
				} else {
				iwuqeyroq8476y4trg.log(
					"WidgetId was not received as a param, awaiting TCL-site to supply the widgetId"
				);
				}
			} else if(window.orPrmConnector && window.orPrmConnector.sendMessage){
			iwuqeyroq8476y4trg.log("Async env detected");
				iwuqeyroq8476y4trg.orPrmConnector = window.orPrmConnector.sendMessage;
				iwuqeyroq8476y4trg.isAsync = true;
			var wid = "";
			if ((wid = getUrlParameter("orFlowWuiaWidgetId")) != "") {
				wid = parseInt(wid);
				iwuqeyroq8476y4trg.log(
					"WidgetId received as a param: " + wid.toString()
				);
					iwuqeyroq8476y4trg.setupEnv(wid);
				} else {
				iwuqeyroq8476y4trg.log(
					"WidgetId was not received as a param, awaiting TCL-site to supply the widgetId"
				);
				}
			} else if (window.external.orPrmConnector) {
			iwuqeyroq8476y4trg.log("Sync env detected");
				iwuqeyroq8476y4trg.orPrmConnector=window.external.orPrmConnector;
				iwuqeyroq8476y4trg.setupEnv(window.external.orPrmWidgetId);
			} else {
			iwuqeyroq8476y4trg.log(
				"The external interface to TCL could not be found"
			);
			}
		} catch(exc){
			iwuqeyroq8476y4trg.log(exc.message);
			setTimeout(_properInitializationReject,0);
		}
			/*debug*/
			/*window.recursesearchorprm('window',window);

			return;*/
			/*end debug*/
		};
	$(window).on('load',iwuqeyroq8476y4trg.init);
		
	/*}*/
	
};






// WEBPACK FOOTER //
// ./src/Tools/orFlowWuia.js